import {
	FlightStore,
	FlightEnrichStore,
	FlightFilterStore,
	IFlightSortFunction,
} from '@move-frontend/dap';
import { SortStore } from '@move-frontend/utils';
import {
	IEnrichedFlightProps,
	IEnrichedFlight,
} from '../../../shared/flight/domain/models/IEnrichedFlight';
import { IFlight } from '../../../shared/flight/domain/models/IFlight';
import { FlightListStore } from './FlightListStore';
import { getFlightTimeForSorting } from '../getFlightTimeForSorting';

export function createFlightListStore(
	flightStore: FlightStore<IFlight>,
	flightEnrichStore: FlightEnrichStore<IFlight, IEnrichedFlightProps>,
) {
	const flightFilterStore = new FlightFilterStore<IEnrichedFlight>();
	const flightSortStore = new SortStore<IEnrichedFlight>(sortFlight);

	return new FlightListStore(
		flightStore,
		flightEnrichStore,
		flightFilterStore,
		flightSortStore,
	);
}

export const sortFlight: IFlightSortFunction = <FlightType extends IFlight>(
	a: FlightType,
	b: FlightType,
) =>
	getFlightTimeForSorting(a) - getFlightTimeForSorting(b) ||
	a.viaAirport.localeCompare(b.viaAirport);
